import { useEffect, useRef, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { useWorkspaceSlug } from '~/api/swr/useWorkspaceSlug.ts'

import { Spinner } from './Loading/index.tsx'

export function RedirectToDashboardOrCreateNewWorkspace() {
  const { slug, isFirstWorkspace } = useWorkspaceSlug()

  const timeout = useRef<NodeJS.Timeout>(undefined)
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    if ((slug || isFirstWorkspace) && !timeout.current) return
    if ((slug || isFirstWorkspace) && timeout) {
      clearTimeout(timeout.current)
      return
    }

    let unmounted = false

    timeout.current = setTimeout(() => {
      if (unmounted) return
      setShowLoading(true)
    }, 400)

    return () => {
      unmounted = true
      clearTimeout(timeout.current)
    }
  }, [isFirstWorkspace, slug])

  if (!slug && !isFirstWorkspace && !showLoading) return null
  if (!slug && !isFirstWorkspace && showLoading) return <Spinner className="loading--page" />

  if (isFirstWorkspace) {
    return <Navigate to="/c/create-workspace" />
  }

  return <Navigate to={`/c/${slug}`} />
}
